import { useState } from "react";
import { useTranslation } from "@/langs/useTranslation";
import MultipleSelector from "@/components/MultipleSelector";
import DeviceGroupsModal from "./DeviceGroupsModal";

const DeviceGroups = ({
  name,
  value,
  onChange,
  disabled,
  clearable,
  checkStrictly = true,
  className,
  style
}) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = (keys, nodes) => {
    onChange?.({ target: { value: keys, name } });
    setOptions(nodes.map(item => ({ id: item.key, name: item.title })));
    handleClose();
  };

  return (
    <>
      <MultipleSelector
        placeholder={t({ defaultMessage: "选择门店" })}
        options={options}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        onClick={() => setOpen(true)}
        noDropdown
        clearable={clearable}
        className={className}
        style={style}
      />
      <DeviceGroupsModal
        open={open}
        checkedKeys={value}
        checkStrictly={checkStrictly}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default DeviceGroups;
